<template>
  <div>
    <base-header class="pb-6 bg-light">

      <div v-if="noAccess">
        <b-card>
          <b-card-header>
            <p class="h2 mb-2">
              <b-icon-exclamation-triangle-fill variant="danger"></b-icon-exclamation-triangle-fill
              >&nbsp;Restricted
            </p>
          </b-card-header>
          <b-card-body>Access is Restricted</b-card-body>
        </b-card>
      </div>

      <div v-else>
        <b-row align-v="center" class="py-4 mb-0">
          <b-col cols="12" lg="8">
            <b-row>
              <b-col sm="5" md="3" lg="3" xl="3">
                <h6 class="h2 d-inline-block mb-0 text-dark nowrap">eSIM Profile Info</h6>
              </b-col>
              <b-col
              v-if="hasData" :key="buttons_idx" 
              xs="4" sm="6" md="9" lg="9" xl="9" class="d-flex align-items-center"
              >
                <!-- <span class="d-flex flex-wrap no-wrap"> -->
                  <base-button :type="getStateClass(profileStatus)" title="current state" size="sm">
                    {{ profileStatus.toUpperCase() }}
                  </base-button>
  
                  <base-button
                    v-if="profileStatus === 'Released' || profileStatus === 'Allocated'"
                    type="warning"
                    title="show qrcode"
                    size="sm"
                    v-on:click="showQrcode"
                  >
                    <i class="fa fa-qrcode"></i>
                  </base-button>
  
                  <base-button
                      v-if="
                      profileStatus === 'Released' ||
                      profileStatus === 'danger' ||
                      profileStatus === 'Allocated' ||
                      profileStatus === 'Linked' ||
                      profileStatus === 'Error'
                    "
                      type="danger"
                      title="Cancel"
                      size="sm"
                      v-on:click="profileActionEvent('Cancel')"
                      :disabled="isReadOnly"
                  >
                    <b-icon icon="x-circle"></b-icon> CANCEL
                  </base-button>
  
                  <base-button
                      type="primary"
                      title="Order"
                      size="sm"
                      @click="showEsimOrderModal()"
                      v-if="profileStatus === 'Available'"
                      :disabled="isReadOnly">
                    <i class="fa fa-qrcode"></i> ORDER
                  </base-button>
                <!-- </span> -->

                <base-button
                    class="ml-auto"
                    type="danger"
                    title="Invalidate"
                    size="sm"
                    @click="invalidateEsim()"
                    v-if="isPortalAdmin">
                  <i class="fa fa-exclamation-triangle"></i> INVALIDATE
                </base-button>
              </b-col>
            </b-row>
          </b-col>

          <b-col cols="12" lg="4" class="text-right">
            <nav aria-label="breadcrumb" class="d-none d-lg-inline-block ml-md-4">
              <route-bread-crumb></route-bread-crumb>
            </nav>
          </b-col>
        </b-row>

        <!-- <b-row class="mb-4">
          <b-col
            v-if="hasData && isPortalAdmin" 
            cols="12" 
          >
            <base-button
              class="ml-4"
              type="danger"
              title="Invalidate"
              size="sm"
              @click="invalidateEsim()"
            >
              <i class="fa fa-exclamation-triangle"></i> 
              INVALIDATE PROFILE
              <i class="fa fa-exclamation-triangle"></i> 
            </base-button>
          </b-col>
        </b-row> -->

        <b-row class="mb-4">
          <b-col xl="6">
            <div class="input-group">
              <b-input-group size="lg">
                <template #prepend>
                  <b-button class="iccid-width ps" style="cursor: default;" variant="primary">ICCID</b-button>
                </template>
                <b-form-input
                    id="iccid"
                    data-cy="e-sim-profile-search-input" type="text"
                    v-model="iccid"
                    @change="loadPageData"
                ></b-form-input>
                <template #append>
                  <base-button
                      v-if="showRefresh"
                      data-cy="e-sim-profile-refresh-btn"
                      type="warning"
                      title="refresh profile"
                      size="sm"
                      v-on:click="refreshPage"
                  >
										<!-- <b-icon icon="recycle"></b-icon> -->
                    <i class="fa fa-recycle"></i>
									</base-button>
                  <base-button 
                    v-else
                    data-cy="e-sim-profile-search-btn" 
                    size="lg" 
                    type="success" 
                    title="Search" 
                    v-on:click="loadPageData"
                  >
                    <i class="fa fa-search"></i>
                  </base-button>
                </template>
              </b-input-group
              >&nbsp;
            </div>
          </b-col>
        </b-row>

        <b-row v-if="!hasData && !submitLoading">
          <b-col xl="12">
            <b-card no-body>
              <b-card-body>
                <div align="center">Please enter a valid iccid that exists in the system.</div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

        <b-row v-else>
          <b-col xl="6">
            <b-card no-body>
              <b-card-body>
                <div class="">
                  <b-table
                      id="profile_table"
                      head-row-variant="primary"
                      :items="profile_data"
                      :fields="profile_fields"
                      fixed
                      show-empty
                      :key="profile_data_idx"
                      head-variant="light"
                      table-class="text-nowrap"
                      class="data-management-table primary-table"
                      sticky-header="true"
                      thead-class="white"
                      responsive
                      small
                  >
                    <template #cell(data_value)="row">
											<span v-if="row.item['data_name'] === 'Status'">
												<base-button
                            size="sm"
                            style="width: 100px"
                            :type="getStateClass(row.item['data_value'])"
                            title="current state"
                            class="nowrap"
                        >{{ row.item["data_value"].toUpperCase() }}</base-button
                        >
											</span>
                      <span v-else>{{ row.item["data_value"] }}</span>
                    </template>

                    <template #empty="scope">
                      <div v-if="submitLoading" class="text-center">
                        <b-icon icon="three-dots" animation="cylon" font-scale="4"/>
                      </div>
                      <div v-else class="text-center">
                        <b>{{ scope.emptyText }}</b>
                      </div>
                    </template>
                  </b-table>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col xl="6">
            <b-card no-body>
              <b-card-body>
                <div class="">
                  <b-table
                      id="sim_table"
                      head-row-variant="primary"
                      :items="sim_data"
                      :fields="sim_fields"
                      show-empty
                      :key="sim_data_idx"
                      head-variant="light"
                      table-class="text-nowrap"
                      class="data-management-table primary-table"
                      sticky-header="true"
                      thead-class="white"
                      responsive
                      small
                  >
                  <template #head(data_value)="row">
                        <base-button
                          data-cy="e-sim-profile-full-response-btn"
                          class="float-right"
                          size="sm"
                          type="warning"
                          title="View full details"
                          v-on:click="$bvModal.show('full-response-modal')"
                        >
                          <i class="fa fa-info-circle"></i> {{ row.value }}
                        </base-button>
                        <base-button
                          v-if="showTacButton"
                          data-cy="e-sim-profile-tac-data-btn"
                          class="float-right mr-2"
                          size="sm"
                          type="info"
                          title="View TAC data"
                          v-on:click="$bvModal.show('tac-data-modal')"
                        >
                          <i class="fa fa-mobile-alt"></i> {{ row.value }}
                        </base-button>
                    </template>
                    <template #cell(data_value)="row">
                      <span v-if="row.item['data_name'] === 'EID' && blacklisted">
                        {{ row.item["data_value"] }}
                        <base-button size="xs" type="danger">BLACKLISTED</base-button>
                      </span>
                      <span v-if="typeof row.item.data_value === 'object'">
                        <tr v-for="(value, key) in row.item.data_value" :key="key">
                          <td class="bg-light-form w-50">{{ key.toUpperCase() }}</td>
                          <td>{{ value }}</td>
                        </tr>
                      </span>
                      <span v-else>{{ row.item["data_value"] }}</span>
                    </template>
      
                    <template #empty="scope">
                      <div v-if="submitLoading" class="text-center">
                        <b-icon icon="three-dots" animation="cylon" font-scale="4"/>
                      </div>
                      <div v-else class="text-center">
                        <b>{{ scope.emptyText }}</b>
                      </div>
                    </template>
                  </b-table>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <!-- Variables Table -->
        <b-row v-if="isPortalAdmin && hasData">
          <b-col>
            <b-card no-body>
              <b-card-body>
                <b-row>
                    <b-col>
                      <b-form-group
                          row
                          label=""
                          label-for="per-page-select"
                          label-cols-sm="0"
                          label-cols-md="0"
                          label-cols-lg="0"
                          label-align-sm="center"
                          label-size="sm"
                          class="mb-2 per-page-select"
                      >
                        <label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
                        <b-form-select
                            id="per-page-select"
                            class="diameter-report-select"
                            v-model="perPage_vars"
                            :options="pageOptions"
                            @change="currentPage_vars = 1"
                            size="sm"
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group
                        label=""
                        label-for="filter-input"
                        label-align-sm="right"
                        label-size="sm "
                        class="mb-0 per-page-select"
                      >
                        <label for="filter-input" class="text-sm mr-2 mt-1">Search</label>
                        <b-input-group size="sm">
                          <b-form-input id="filter-input2" v-model="filter_vars" ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                </b-row>
                <b-table
                  data-cy="eSim-profile-vars-table"
                  id="variables_table"
                  :items="variables"
                  :fields="variables_fields"
                  :per-page="perPage_vars"
                  :current-page="currentPage_vars"
                  :filter="filter_vars"
                  show-empty
                  :key="sim_data_idx"
                  head-variant="light"
                  table-class="text-nowrap"
                  class="data-management-table primary-table"
                  sticky-header="true"
                  thead-class="white"
                  responsive
                  small
                >
                  <template #cell(edit)="row">
                    <i
                      v-if="!selected_vars.includes(row.index) && !non_editable.includes(row.item['data_name'])"
                      :title="`Edit ${row.item['data_name']}`"
                      v-b-tooltip.hover
                      class="fas fa-pen-nib cursor-pointer text-success"
                      @click="varClick(row)"
                    ></i>
                    <i
                      v-else-if="selected_vars.includes(row.index)"
                      title="Cancel Edit"
                      v-b-tooltip.hover
                      class="fas fa-window-close cursor-pointer text-danger"
                      @click="varClick(row)"
                      style="cursor: pointer;"
                    ></i>
                    <i 
                      v-else
                      title="Locked"
                      v-b-tooltip.hover
                      class="fas fa-lock cursor-pointer text-info"
                      style="cursor: not-allowed;"
                    ></i>
                  </template>
                  
                  <template #cell(value)="row">
                    <div
                      v-if="selected_vars.includes(row.index)"
                      class="d-flex align-items-center"
                    >
                      <b-form-input
                        v-model="var_updates[row.item.data_name]"
                        size="sm"
                        class="w-75"
                      ></b-form-input>
                      <b-button
                        class="ml-4"
                        size="sm"
                        variant="success"
                        title="Not yet implemented"
                        v-b-modal="'confirm-update-modal'"
                        @click="update_target = row.item.data_name"
                        :disabled="true"
                      >
                        <i class="fa fa-save"></i> Save
                      </b-button>
                    </div>
                    <span v-else>{{ row.item["value"] }}</span>
                  </template>

                  <template #empty="scope">
                    <div v-if="submitLoading" class="text-center">
                      <b-icon icon="three-dots" animation="cylon" font-scale="4"/>
                    </div>
                    <div v-else class="text-center">
                      <b>{{ scope.emptyText }}</b>
                    </div>
                  </template>
                </b-table>
                <b-row class="mt-4">
                  <b-col>
                    <p class="ml-3 nowrap">{{ startPage(currentPage_vars, perPage_vars) }} - {{ lastPage(currentPage_vars, perPage_vars, totalRows_vars) }} of {{ totalRows_vars }}</p>
                  </b-col>
                  <b-col v-if="totalRows_vars > perPage_vars">
                    <b-pagination
                        class="flex-fill-custom pr-4 ml-3 justify-content-end"
                        v-model="currentPage_vars"
                        :total-rows="totalRows_vars"
                        :per-page="perPage_vars"
                        size="sm"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <!-- Activity Table -->
        <b-row v-if="hasData">
          <b-col>
            <b-card no-body>
              <b-card-body>
                <div class="">
                  <b-row>
                    <b-col>
                      <b-form-group
                          row
                          label=""
                          label-for="per-page-select"
                          label-cols-sm="0"
                          label-cols-md="0"
                          label-cols-lg="0"
                          label-align-sm="center"
                          label-size="sm"
                          class="mb-2 per-page-select"
                      >
                        <label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
                        <b-form-select
                            id="per-page-select"
                            class="diameter-report-select"
                            v-model="perPage"
                            :options="pageOptions"
                            size="sm"
                            v-on:input="changePageOption(perPage)"
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group
                        label=""
                        label-for="filter-input"
                        label-align-sm="right"
                        label-size="sm "
                        class="mb-0 per-page-select"
                      >
                        <label for="filter-input" class="text-sm mr-2 mt-1">Search</label>
                        <b-input-group size="sm">
                          <b-form-input id="filter-input2" v-model="filter" ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-table
                      id="activity_table"
                      ref="activity_table"
                      :items="activity_data"
                      :fields="activity_fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      :key="activity_data_idx"
                      class="primary-table"
                      show-empty
                      responsive
                      striped
                      hover
                      @sort-changed="onSortChanged($event)"
                      @filtered="onFiltered"
                  >
                    <template #cell(Status)="row">
                      <base-button
                          title="View record details in sidebar"
                          v-b-toggle.activity-sidebar-right
                          size="xs"
                          style="width: 100px"
                          :type="getStateClass(row.item['Status'])"
                          class="nowrap"
                          v-on:click="openSidePanle(row.item.original)"
                      >
                        {{ row.item["Status"] }}
                      </base-button>
                    </template>
  
                    <template #cell(Details)="row">
                      <!-- <base-button size="xs" type="light" v-on:click="getActivityDetail(row.item['id'])">
                        <b-icon icon="info-circle-fill" aria-label="More"></b-icon>
                      </base-button> -->
                      <i
                        v-if="selectedRows.includes(row.index)"
                        title="Collapse details"
                        v-b-tooltip.hover
                        class="fa fa-minus-circle"
                        style="cursor: pointer;"
                        @click="rowClick(row)"
                      ></i>
                      <i
                        v-else
                        title="Expand details"
                        v-b-tooltip.hover
                        class="fa fa-plus-circle"
                        @click="rowClick(row)"
                        style="cursor: pointer;"
                      ></i>
                    </template>
  
                    <template #row-details="row">
                      <table class="under-table w-auto">
                        <tr v-for="(item, i) of row.item.original" :key="i">
                          <td class="bg-light-form w-50">
                            {{ item.title.toUpperCase() }}
                          </td>
                          <td v-if="item.title.includes('state')">
                            <!-- <base-button
                                size="sm"
                                style="width: 100px"
                                :type="getStateClass(item.value)"
                                title="current state"
                                class="nowrap"
                            >{{ item.value.toUpperCase() }}</base-button> -->
                            <!-- Show sim state as a badge instead of a button -->
                            <b-badge
                                size="sm"
                                :variant="getStateClass(item.value)"
                                title="current state"
                                class="nowrap"
                            >{{ item.value.toUpperCase() }}</b-badge>
                          </td>
                          <td v-else>
                            {{ item.value }}
                          </td>
                        </tr>
                      </table>
                    </template>
  
                    <template #empty="scope">
                      <div v-if="submitLoading" class="text-center">
                        <b-icon icon="three-dots" animation="cylon" font-scale="4"/>
                      </div>
                      <div v-else class="text-center">
                        <b>{{ scope.emptyText }}</b>
                      </div>
                    </template>
                  </b-table>
  
                  <b-row class="mt-4">
                    <b-col>
                      <p class="ml-3 nowrap">{{ startPage(currentPage, perPage) }} - {{ lastPage(currentPage, perPage, totalRows) }} of {{ totalRows }}</p>
                    </b-col>
                    <b-col v-if="totalRows > perPage">
                      <b-pagination
                          class="flex-fill-custom pr-4 ml-3 justify-content-end"
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          size="sm"
                      ></b-pagination>
                    </b-col>
                  </b-row>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </base-header>

    <!-- ACTIVITY LOG DETAIL STARTS -->
    <b-sidebar id="activity-sidebar-right" width="360px" sidebar-class="border-left border-secondary" right shadow>
      <template #header>
        <section class="d-flex align-content-center w-100">
          <b-button v-b-toggle.activity-sidebar-right variant="light" class="p-0 shadow-none">
            <b-icon icon="x-lg" font-scale="1"/>
          </b-button>
          <div class="w-100 text-center font-weight-bolder">Activity Status</div>
        </section>
      </template>
      <b-card class="shadow-none">
        <b-card-text v-for="(item, i) of activity_selected" :key="i">
          <div class="font-weight-bold text-capitalize">
            {{ item.title }}
          </div>
          {{ item.value }}
        </b-card-text>
      </b-card>
    </b-sidebar>
    <!-- ACTIVITY LOG DETAIL ENDS -->

    <!-- MODALS -->
    <EsimOrderModal
        :iccid="iccid"
    />
    
    <EsimInvalidateModal
        :iccid="iccid"
    />

    <b-modal id="activityModal" size="xs" centered hide-footer>
      <template #modal-title> Log details</template>
      <div class="table-responsive">
        <table class="table-bordered" cellpadding="10" cellspacing="2">
          <tr>
            <td colspan="2">
              <b>Profile Management</b><br/>
              <i>{{ activity.invocationName }}</i
              ><br/>
            </td>
          </tr>
          <tr>
            <td class="bg-light">Profile-Id</td>
            <td>{{ this.iccid }}</td>
          </tr>
          <tr>
            <td colspan="2" class="bg-light"><b>Invocation</b><br/></td>
          </tr>
          <tr>
            <td class="bg-light">Date</td>
            <td>{{ activity.processingStart }}</td>
          </tr>
          <tr>
            <td class="bg-light">ID</td>
            <td>{{ activity.invocationId }}</td>
          </tr>
          <tr>
            <td class="bg-light">Duration</td>
            <td>({{ activity.duration }}) ms</td>
          </tr>
        </table>
      </div>
    </b-modal>
    <!-- Full Details Modal -->
    <b-modal id="full-response-modal" size="lg" centered ok-only>
      <template #modal-title> Full Response</template>
      <b-tabs>
        <b-tab title="Table">
          <b-table
            id="full-response-table"
            :items="modalData"
            :fields="modal_fields"
            head-variant="light"
            table-class="text-nowrap"
            class="data-management-table primary-table"
            sticky-header="true"
            thead-class="white"
            responsive
            small
          >
            <template #cell(key)="row">
              {{ row.item["key"].toUpperCase() }}
            </template>

            <template #cell(value)="row">
              <span v-if="typeof row.item.value === 'object'">
                <tr v-for="(value, key) in row.item.value" :key="key">
                  <td class="bg-light-form w-50">{{ key.toUpperCase() }}</td>
                  <td>{{ value }}</td>
                </tr>
              </span>
              <span v-else>{{ row.item["value"] }}</span>
            </template>
    
            <template #empty="scope">
              <div v-if="submitLoading" class="text-center">
                <b-icon icon="three-dots" animation="cylon" font-scale="4"/>
              </div>
              <div v-else class="text-center">
                <b>{{ scope.emptyText }}</b>
              </div>
            </template>
          </b-table>
        </b-tab>
        <b-tab title="Raw">
          <span class="responsive-table">
            <div v-highlight class="overflow-auto w-auto h-auto">
              <pre><code class="json">{{
                // printJson(profile_data_src.data)
                printJson(rawData)
              }}</code></pre>
            </div>
          </span>
        </b-tab>
      </b-tabs>
    </b-modal>
    <!-- TAC Data Modal -->
    <b-modal id="tac-data-modal" size="lg" centered hide-footer>
      <template #modal-title> TAC Data</template>
          <b-table
            id="tac-data-table"
            :items="tac_data"
            :fields="sim_fields"
            head-variant="light"
            table-class="text-nowrap"
            class="data-management-table primary-table"
            sticky-header="true"
            thead-class="white"
            responsive
            small
          >
            <template #cell(data_value)="row">
              <span v-if="typeof row.item.data_value === 'object'">
                <tr v-for="(value, key) in row.item.data_value" :key="key">
                  <td class="bg-light-form w-50">{{ key.toUpperCase() }}</td>
                  <td>{{ value }}</td>
                </tr>
              </span>
              <span v-else>{{ row.item["data_value"] }}</span>
            </template>
    
            <template #empty="scope">
              <div v-if="submitLoading" class="text-center">
                <b-icon icon="three-dots" animation="cylon" font-scale="4"/>
              </div>
              <div v-else class="text-center">
                <b>{{ scope.emptyText }}</b>
              </div>
            </template>
          </b-table>
    </b-modal>

    <b-modal id="qrCodeModal" size="md" centered hide-footer class="bg-light text-black">
      <template #modal-title> QR Code</template>
      <div>
        <table>
          <tr>
            <td rowspan="4">
              <qrcode-vue :value="qrcodeSrc" size="100" level="H">
                {{ qrcodeSrc }}
              </qrcode-vue>
            </td>
            <td rowspan="4">&nbsp;</td>
            <td>ICCID</td>
            <td>
              <barcode :value="iccid" format="code128" width="2" height="20">
                {{ iccid }}
              </barcode>
            </td>
          </tr>
          <tr>
            <td>IMSI</td>
            <td>{{ imsi }}</td>
          </tr>
          <tr>
            <td>SM-DP+</td>
            <td>{{ smdpAddress }}</td>
          </tr>
          <tr>
            <td>Activation code</td>
            <td>{{ matchingId }}</td>
          </tr>
        </table>
      </div>
    </b-modal>

    <!-- Confirm Variable Update -->
    <b-modal id="confirm-update-modal" size="sm" centered hide-footer>
      <template #modal-title>Confirm Update</template>
      <div class="text-center">
        <p>Are you sure you want to update <b>{{ update_target }}</b> from </p>
        <p><b>{{ profile_data_src.data.variables[update_target] }}</b> to <b>{{ var_updates[update_target] }}</b>?</p>
        <base-button
            class="mt-3"
            type="primary"
            :loading="submitLoading"
            @click="updateSimVariable(update_target)"
        >
          Yes
        </base-button>
        <b-button
            class="mt-3"
            variant="danger"
            @click="$bvModal.hide('confirm-update-modal')"
        >
          No
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import VueBarcode, { data } from "vue-barcode";
import QrcodeVue from "qrcode.vue";
import eSimDashboardService from "@/common/api-services/esim-dashboard-service";
import moment from "moment";
import commonService from "@/common/api-services/common";
import initService from "@/common/api-services/init-service";
import authService from "@/common/api-services/auth-service";
import {v4 as uuidv4} from "uuid";
import ToastVue from "../../Components/Toast.vue";
import EsimOrderModal from "../../Components/Esim-Order-Modal.vue";
import EsimInvalidateModal from "../../Components/Esim-Invalidate-Modal.vue";
import pagination from "../../../common/format/pagination";
import coreutils from "@/common/coreutils";

export default {
  components: {
    RouteBreadCrumb,
    barcode: VueBarcode,
    QrcodeVue,
    ToastVue,
    EsimOrderModal,
    EsimInvalidateModal,
  },

  data() {
    return {
      submitLoading: false,
      hasData: false,
      ps: "background-color:rgba(94,114,228);color:#FFFFFF;width:150px",

      iccid: "",
      prevIccid: "",
      imsi: "",
      eid: "",
      smdpAddress: "smdp.io",
      matchingId: "",
      confirmationCode: "",
      profileType: "",
      finalProfileStatusIndicator: "Available",

      blacklisted: false,
      qrcodeSrc: null,
      barcodeSrc: null,

      //setup for alert
      alertShow: false,
      alertVariant: "success",
      alertMessage: "",

      //setup styles
      profileActionStyle: "danger",
      profileActionIcon: "x-circle",
      profileActionText: "Cancel",
      profileStatus: "Unknown",

      //DATA

      //selectected activity detail
      activity: {
        invocationId: "",
        invocationName: "",
        iccid: "",
        processingStart: "",
        processingEnd: "",
        duration: 0,
      },

      //buttons
      buttons_idx: 4000,

      //profile list
      profile_data_idx: 1000,
      profile_data_src: {
        data: {
          variables: {},
        },
      },
      profile_data: [],
      profile_fields: [
        {key: "data_name", label: "Profile Details"},
        {key: "data_value", label: ""},
      ],

      //activity list
      activity_data_idx: 2000,
      activity_data_src: [],
      activity_data: [],
      activity_fields: [
        {key: 'Details', label: 'Sim Events'},
        {key: "Modified", label: "Modified", sortable: true},
        {key: "Action", label: "Action", sortable: true},
        {key: "Status", label: "Status", sortable: true},
      ],
      activity_title: [{key: "title", label: "Activity Log"}],
      activity_selected: null,

      //sim list
      sim_data_idx: 3000,
      sim_data_src: [],
      sim_data: [],
      sim_fields: [
        {key: "data_name", label: "Sim Details"},
        {key: "data_value", label: ""},
      ],

      //tac data
      tac_data: [
        { data_name: "TAC", data_value: "Not Available" },
        { data_name: "Manufacturer", data_value: "Not Available" },
        { data_name: "Model", data_value: "Not Available" },
        { data_name: "Operating System", data_value: "Not Available" },
        { data_name: "Radio Access Technology", data_value: "Not Available" },
        { data_name: "IMEI", data_value: "Not Available" },
        { data_name: "IMEI SV", data_value: "Not Available" },
      ],

      //variables list table
      variables: [],
      non_editable: ["ICCID", "ICCID_NON_SWAPPED", "IMSI"],
      variables_fields: [
        {key: 'edit', label: ""},
        {key: "data_name", label: "Sim Variables"},
        {key: "value", label: ""},
      ],
      currentPage_vars: 1,
      perPage_vars: 5,
      filter_vars: null,
      selected_vars: [],
      var_updates: {},
      update_target: "",

      modal_fields: [
        {key: "key", label: "Key"},
        {key: "value", label: "Value"},
      ],

      //ACCESS ROLES
      isReadOnly: true,
      isEditor: false,
      isAdministrator: false,
      isPortalAdmin: false,

      // TABLE ACTIVITY LOG
      sortBy: "Modified",
      sortDesc: true,
      sortDirection: "desc",
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      fromPage: 10,
      pageOptions: [5, 10, 25, 50, 100],
      filter: null,
      filterOn: [],
      selectedRows: [],
    };
  },

  mounted() {
    document.title = "eSIM - Profile";

    /** NOTE: The following needs to be in data:
     noAccess: true,
     isReadOnly: true,
     isEditor: false,
     isAdministrator: false,
     isPortalAdmin: false,
     */

    //The user needs to be notified that this is not accessible.

    //set the roles [isReadOnly, isEditor, isAdministrator, isPortalAdmin]
    this.isReadOnly = initService.getUserRoles().includes("ESIM_READ");
    this.isEditor = initService.getUserRoles().includes("ESIM_EDIT");
    this.isAdministrator =
        initService.getUserRoles().includes("PORTAL_ADMIN") ||
        initService.getUserRoles().includes("CARRIER_ADMIN") ||
        initService.getUserRoles().includes("ESIM_ADMIN");
    this.isPortalAdmin = initService.getPortalAdminRole();

    //write to console.
    // console.log("PAGE:", document.title);
    // console.log("isReadOnly:", this.isReadOnly);
    // console.log("isEditor:", this.isEditor);
    // console.log("isAdministrator:", this.isAdministrator);
    // console.log("isPortalAdmin:", this.isPortalAdmin);

    //don't do anything unless the user has access
    if (!this.noAccess) {

      this.$root.$on("esimProfileReloadPage", () => {
        this.refreshPage();
      });

      if (this.$route.query.iccid !== "" && typeof this.$route.query.iccid !== "undefined")
        this.iccid = this.$route.query.iccid;
      else this.readCache();
      this.loadPageData();
    } else {
      this.$router.push('/restricted')
    }
  },
	computed: {
		noAccess() {
			// Determine access based on menu link configuration
			// console.log(this.$route.path.split(':')[0])
			// console.log(this.$route.query)
			let userRoles = initService.getUserRoles();
      let linkQuery = this.$route.path.split(':')[0];
			let link = this.$store.getters["getLinkByLink"](linkQuery.toLowerCase() + ":id");
      
			if (!link) {
				return true;
			} else {
				userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
				return userRoles.length === 0;
			}
		},
    showRefresh() {
      if (this.iccid.length < 1) {
        return false;
      }
      return this.iccid === this.prevIccid;
    },
    showTacButton() {
      return false;
      return this.sim_data.some((item) => item.data_name === "TAC");
    },
    totalRows_vars() {
      return this.variables.length;
    },
    modalData() {
      let order = ["function execution status", "matching id", "iccid", "imsi", "eid", "created", "first installed date time", "last modified", "profile id", "profile type", "profile action", "profile status", "profile owner", "profile classifier"]
      let data = [];
      let src = this.profile_data_src.data;
      for (let key in src) {
        if (src.hasOwnProperty(key)) {
          let value = src[key];
          if (!value) {
            if (value === false) {
              value = "FALSE";
            } else {
              value = "Not Available"
            }
          }
          if (key === "variables") {
            continue;
          }
          if (key === "header") {
            data.push({
              key: "Function Execution Status",
              value: src[key]['functionExecutionStatus'].status,
            });
            continue;
          }
          let date_keys = ["created", "lastModified", "modified", "firstInstalledDateTime"];
          if (date_keys.includes(key)) {
            value = moment(new Date(value)).format("MMM DD, YYYY hh:mm:ss A");
          }

          key = key.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
            return str.toUpperCase();
          });
          data.push({
            key: key,
            value: value,
          });
        }
      }
      data = data.sort((a, b) => {
        // sort data so the values are in the order of the order array first
        let aIndex = order.indexOf(a.key.toLowerCase());
        let bIndex = order.indexOf(b.key.toLowerCase());
        if (aIndex === -1) {
          aIndex = 1000;
        }
        if (bIndex === -1) {
          bIndex = 1000;
        }
        return aIndex - bIndex;
      });
      return data;
    },
    rawData() {
      let res = {}
      for (let key in this.profile_data_src.data) {
        if (key !== "variables" || this.isPortalAdmin) {
          res[key] = this.profile_data_src.data[key];
        }
      }
      // console.log("rawData", res);
      return JSON.stringify(res, null, 2);
    },
	},
  methods: {

    rowClick(row) {
      // console.log("rowClick", row);
      if (this.selectedRows.includes(row.index)) {
        this.selectedRows.splice(this.selectedRows.indexOf(row.index), 1);
      } else {
        this.selectedRows.push(row.index);
      }
      row.toggleDetails();
    },

    varClick(row) {
      // console.log("varClick", row);
      if (this.selected_vars.includes(row.index)) {
        this.selected_vars.splice(this.selected_vars.indexOf(row.index), 1);
      } else {
        this.var_updates[row.item.data_name] = row.item.value;
        this.selected_vars.push(row.index);
      }
    },

    async updateSimVariable(name) {
      // console.log("updateSimVariable", name);
      this.submitLoading = true;
      let data = {
        iccid: this.iccid,
        name: name,
        value: this.var_updates[name],
      };
      // console.log("updateSimVariable", data);
      eSimDashboardService.updateProfileVariable(data)
        .then((res) => {
          // console.log("updateSimVariable", res);
          this.selected_vars = [];
          this.var_updates = {};
          this.refreshPage();
          this.showToasterMsg("Variable updated successfully", "success");
        })
        .catch((e) => {
          console.error("updateSimVariable", e);
          this.showToasterMsg("[updateSimVariable]Error:" + e.message, "danger");
        })
        .finally(() => {
          this.submitLoading = false;
          this.$bvModal.hide("confirm-update-modal");
        });
    },

    getTotalRows() {
      if (this.perPage > this.totalRows) {
        this.fromPage = this.totalRows;
      } else {
        this.fromPage = this.perPage;
      }
    },

    changePageOption(page) {
      this.getTotalRows();
    },

    startPage(currentPage, perPage) {
      return pagination.startPageFunc(currentPage, perPage);
    },

    lastPage(currentPage, perPage, totalRows) {
      return pagination.lastPageFunc(currentPage, perPage, totalRows);
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    cDate(str) {
      return commonService.strToDate(str);
    },

    readCache() {
      //get the last saved filter criteria
      let search = localStorage.getItem(this.$route.name);
      // console.log("esim reading search:", search);
      if (search) {
        search = JSON.parse(search);
        if (search.iccid) this.iccid = search.iccid;
      }
    },

    writeCache() {
      //set to current filter criteria
      let search = {
        iccid: this.iccid,
      };
      // console.log("esim writing search:", search);
      localStorage.setItem(this.$route.name, JSON.stringify(search));
    },

    printJson(text) {
      return coreutils.formatJson(text);
    },

    async loadPageData() {
      try {
        this.submitLoading = true;
        this.clearData();
        if (!this.iccid || this.iccid.length !== 20) {
          throw new Error("Invalid ICCID.");
        } else {   
          this.getProfileData();
          this.getActivityData();
          this.writeCache();
        }
      } catch (e) {
        //console.error(e);
        //this.showToasterMsg("[loadPage]Error:" + e.message, "danger");
        this.hasData = false;
        this.submitLoading = false;
      }
    },

    clearData() {
      this.prevIccid = this.iccid;
      this.hasData = false;
      this.submitLoading = true;
      this.profile_data = [];
      this.sim_data = [];
      this.variables = [];
      this.activity_data = [];
      this.selectedRows = [];
      this.selected_vars = [];
      this.var_updates = {};
      this.update_target = "";
    },

    showEsimOrderModal() {
      this.$bvModal.show("eSimOrderModal");
    },
    
    invalidateEsim() {
      this.$bvModal.show("eSimInvalidateModal");
    },

    showQrcode() {
      this.$bvModal.show("qrCodeModal");
      try {
        this.qrcodeSrc = "LPA:1$" + this.smdpAddress + "$" + this.matchingId;
        this.barcodeSrc = this.iccid;
        authService.setActivityLog("ESIM:showQrcode", "show qrcode OK: " + this.iccid, 0);
      } catch (e) {
        authService.setActivityLog("ESIM:showQrcode", JSON.stringify(e), 1);
        this.showToasterMsg("[showQrcode]Error:" + e.message, "danger");
      }
    },

    getStateClass(state) {
      return eSimDashboardService.getStateClass(state);
    },

    async getProfileData() {
      let profile_status = "Unknown";
      let myProfileType = "";
      this.submitLoading = true;
      let profile_order = [
        "profile template",
        "status",
        "profile id",
        "profile type",
        "lastModified",
        "created",
      ];
      let var_order = [
        "iccid",
        "iccid_non_swapped",
        "imsi",
        "tls",
        "psk",
        "kic",
        "kid",
        "pin1",
        "pin2",
        "puk1",
        "puk2",
      ];
      await eSimDashboardService.getProfile(this.iccid).then(res => {
        // console.log(res);
        let error = res.data.header.functionExecutionStatus.status !== "Executed-Success";
        if (!error && res.data) {
          this.profile_data_src = res;
          let d = [];
          Object.keys(res.data).forEach(function (data_key) {
            let data_val = "";
            if (data_key === "profileId") {
              data_val = res.data[data_key];
              data_key = "Profile ID";
            } else if (data_key === "profileType") {
              data_val = res.data[data_key];
              data_key = "Profile Template";
              myProfileType = data_val;
            } else if (data_key === "profileStatus") {
              data_val = res.data[data_key];
              data_key = "Status";
              profile_status = data_val;
            } else if (data_key === "lastModified") {
              data_val = moment(res.data[data_key]).format("MMM DD, YYYY hh:mm:ss");
              data_key = "Last Updated";
            } else if (data_key === "created") {
              data_val = moment(res.data[data_key]).format("MMM DD, YYYY hh:mm:ss");
              data_key = "Created";
            } else {
              data_key = "";
            }
            if (data_key !== "" && data_val !== "") {
              d.push({data_name: data_key, data_value: data_val});
            }
          });
          if (res.data.hasOwnProperty("variables")) {
            // console.log(res.data.variables);
            let arr = [];
            Object.keys(res.data.variables).forEach(function (data_key) {
              let data_val = res.data.variables[data_key];
              arr.push({data_name: data_key, value: data_val});
            });
            this.variables = arr;
          }
          this.profileType = myProfileType;
          this.profile_data = d;
          this.profileStatus = profile_status;
          this.hasData = true;
          this.sortTableData(this.profile_data, profile_order);
          this.sortTableData(this.variables, var_order);
        } else {
          this.hasData = false;
        }
      });
      await this.getSimData();
      this.submitLoading = false;
    },

    async getSimData() {
      let myEID, myMSISDN, myIMSI, myICCID, myMatchingId;
      
      //eSimDashboardService.getProfile(this.iccid).then(res => {
      let res = this.profile_data_src;
      let sim_details_order = [
        "matching id",
        "iccid",
        "imsi",
        "msisdn",
        "eid",
        "tac",
      ];
      if (res) {
        //this.sim_data_src = res.data;
        let d = [];
        Object.keys(res.data).forEach(function (data_key) {
          let data_val = "";
          if (data_key === "iccid") {
            data_val = res.data[data_key];
            data_key = "ICCID";
            myICCID = data_val;
          } else if (data_key === "profileOwner") {
            data_val = res.data[data_key];
            data_key = "EID";
            myEID = data_val;
          } else if (data_key === "matchingId") {
            data_val = res.data[data_key];
            data_key = "Matching ID";
            myMatchingId = data_val;
          } else if (data_key === "msisdn") {
            data_val = res.data[data_key];
            data_key = "MSISDN";
            myMSISDN = data_val;
          } else if (data_key === "imsi") {
            data_val = res.data[data_key];
            data_key = "IMSI";
            myIMSI = data_val;
          } else if (data_key === "profileOwningDevice") {
            data_val = res.data[data_key];
            if (data_val.hasOwnProperty('tac')) {
              data_val = data_val.tac;
              data_key = "TAC";
            }
          } else {
            data_key = "";
          }
          if (data_key !== "" && data_val !== "") {
            d.push({data_name: data_key, data_value: data_val});
          }
        });
        this.iccid = myICCID;
        this.imsi = myIMSI;
        this.eid = myEID;
        this.matchingId = myMatchingId;
        this.msisdn = myMSISDN;
        if (!myIMSI) d.push({data_name: "IMSI", data_value: "Not Set"});
        //if (!myEID) d.push({'data_name': 'EID', 'data_value': 'Not Set'});
        //if (!myMSISDN) d.push({'data_name': 'MSISDN', 'data_value': 'Not Set'});
        this.sim_data = this.sortTableData(d, sim_details_order);
      }
      //});
    },

    async getActivityData() {
      eSimDashboardService
          .getProfileTransitions(this.iccid)
          .then(res => {
            this.activity_data_src = res;
            let d = [];
            res.data.transitions.forEach(item => {
              // console.log(item)
              //invocationId
              let id = ""; //commonService.dateToInt(item['event_timestamp']);
              //Modified
              let m = new Date(item["event_timestamp"]);
              m = moment(m).format("MMM DD, YYYY hh:mm:ss");
              //Action
              let a = commonService.getLastKey(item["function"], ".", " ", true);
              //Status
              let s = String(item["new_state"]).toUpperCase();
              if (s === "UNDEFINED") s = "DELETED";
              let original = this.showActivitySelected(structuredClone(item));
              // console.log('original',original);
              original.map((item) => {
                if (String(item.title).toLowerCase() === "date") {
                  item.value = moment(new Date(item.value)).format("MMM DD, YYYY hh:mm:ss");
                }
                return item;
              });
              //add row to data object
              d.push({id: id, Modified: m, Action: a, Status: s, original: original});
            });
            this.activity_data = d;
            this.totalRows = d.length;
            // console.log('getActivityData',d);
            this.onSortChanged({sortBy: 'date', sortDesc: true});
          })
          .catch(err => {
            this.$toast.error(err.message);
          });
    },

    getActivityDetail(id) {
      eSimDashboardService.getActivityDetail(id).then(res => {
        //now show the model.
        res.invocationName = commonService.getLastKey(res.invocationName, ".", " ", true);
        res.duration = res.processingEnd - res.processingStart;
        this.activity = res;
        this.$bvModal.show("activityModal");
      });
    },

    profileActionEvent(event) {
      //clear params.
      this.cleanVariables();
      if (event === "Cancel") {
        //Cancel Order
        let msg =
            "You are about to cancel this profile. After this operation the profile should be back in Available state.";
        this.$bvModal
            .msgBoxConfirm(msg, {
              title: "Confirmation",
              size: "sm",
              buttonSize: "sm",
              okVariant: "danger",
              okTitle: "APPLY",
              cancelTitle: "CANCEL",
              footerClass: "p-2",
              hideHeaderClose: false,
              centered: true,
            })
            .then(value => {
              if (value === true) {
                //Cancel order successful
                eSimDashboardService
                    .cancelOrder(this.iccid, this.eid, this.matchingId, this.finalProfileStatusIndicator)
                    .then(res => {
                      //console.log('cancelOrder:',res.data);
                      let status = String(res.data.header.functionExecutionStatus.status);
                      authService.setActivityLog(
                          "ESIM:downloadConfirmOrder",
                          status + ": " + this.iccid,
                          0
                      );
                      if (status !== "Failed") {
                        this.showToasterMsg(" Cancel order successful " + this.iccid);
                        setTimeout(() => {
                          this.refreshPage();
                        }, 1000);
                      } else {
                        this.showToasterMsg(" Cancel order failed " + this.iccid, "danger");
                      }
                    });
              }
            })
            .catch(err => {
              authService.setActivityLog("ESIM:downloadConfirmOrder", JSON.stringify(err), 1);
              // An error occurred
              this.showToasterMsg(" Cancel order failed ", "danger");
            })
      } else if (event === "Blacklist") {
        //Blacklist device
        let msg =
            "You are about to blacklist the device with this profile.\n" +
            "  After this operation the device with EID " +
            this.eid +
            " will not be able to install any profiles.";
        this.$bvModal
            .msgBoxConfirm(msg, {
              title: "Confirmation",
              size: "sm",
              buttonSize: "sm",
              okVariant: "danger",
              okTitle: "APPLY",
              cancelTitle: "CANCEL",
              footerClass: "p-2",
              hideHeaderClose: false,
              centered: true,
            })
            .then(value => {
              if (value === true) {
                //Cancel order successful
                eSimDashboardService.addBlacklist(this.eid).then(res => {
                  //console.log("addBlacklist:", res);
                  if (!res) throw Error(res);
                  this.showToasterMsg(" Blacklist device successful ");
                  setTimeout(() => {
                    this.refreshPage();
                  }, 1000);
                });
              }
            })
            .catch(err => {
              // An error occurred
              this.showToasterMsg(" Blacklist device failed ", "danger");
            });
      } else {
        //NOT VALID
      }
    },

    sortTableData(array, template) {
      array.sort((a, b) => {
        if (template.includes(a.data_name.toLowerCase()) && template.includes(b.data_name.toLowerCase())) {
          return template.indexOf(a.data_name.toLowerCase()) - template.indexOf(b.data_name.toLowerCase());
        } else if (template.includes(a.data_name.toLowerCase())) {
          return -1;
        } else if (template.includes(b.data_name.toLowerCase())) {
          return 1;
        }
      });
      return array;
    },

    onSortChanged(sortInfo) {
      if (!this.activity_data.length) {
        return;
      }
      const { sortBy, sortDesc } = sortInfo;
      // console.log("sortInfo", sortBy);
      this.sortBy = sortBy;
      this.sortDirection = sortDesc ? 'desc' : 'asc';
      let sorted_data = this.activity_data.sort((a, b) => {
        // console.log(a[sortBy]);
        let comparision_a = a[sortBy];
        let comparision_b = b[sortBy];
        if (sortBy === "date") {
          comparision_a = new Date(a[sortBy]).getTime();
          comparision_b = new Date(b[sortBy]).getTime();
        }
        
        // console.log("comparision_a", comparision_a);
        // console.log("comparision_b", comparision_b);
        if (comparision_a === comparision_b) {
          return 0;
        }
        if (sortDesc) {
          return comparision_a < comparision_b ? 1 : -1;
        } else {
          return comparision_a > comparision_b ? 1 : -1;
        }
      });
      // console.log(this.carrierFiles);
      // console.log("new_log_data", new_log_data);
      this.activity_data = sorted_data;
    },

    refreshPage() {
      this.submitLoading = true;
      this.clearData();
      this.loadPageData();
    },

    showToasterMsg(message, variant = "success") {
      if (variant === "danger") {
        variant = "error";
      }
      //setup for alert
      this.$toast(
          {
            component: ToastVue,
            props: {
              description: message,
            },
          },
          {
            type: variant,
          }
      );
    },

    cleanVariables() {
      if (!this.imsi || this.imsi === "undefined") this.imsi = "";
      if (!this.iccid || this.iccid === "undefined") this.iccid = "";
      if (!this.eid || this.eid === "undefined") this.eid = "";
      if (!this.smdpAddress || this.smdpAddress === "undefined") this.smdpAddress = "";
      if (!this.matchingId || this.matchingId === "undefined") this.matchingId = "";
      if (!this.profileType || this.profileType === "undefined") this.profileType = "";
      if (!this.confirmationCode || this.confirmationCode === "undefined") this.confirmationCode = "";
      if (!this.finalProfileStatusIndicator || this.finalProfileStatusIndicator === "undefined")
        this.profileType = "Available";
    },

    openSidePanle(data) {
      this.activity_selected = data;
    },

    showActivitySelected(item) {
      let informations = [];
      for (const key of Object.keys(item)) {
        if (!item[key]) continue;
        let title = "";
        let value = item[key];
        if (key == "event_timestamp") {
          title = "Date";
          value = commonService.strToDate(item[key]);
        } else if (key == "function") {
          title = "Action";
          value = commonService.getLastKey(item[key], ".", " ", true);
        } else {
          title = key.split("_").join(" ");
        }
        informations.push({title, value});
      }
      // this.activity_selected = informations;
      return informations;
    },

    showDetails(detail) {
      if (detail === "Available") {
        eSimDashboardService.esimGetprofileinstallerrors(this.iccid).then(res => {
          if (res.data.errors.length) {
            let misMatch = res.data.errors[0].error_reason;
            this.$notify({
              title: "Handle Notification",
              message: `<div>
                            <div class="version">ES9</div>
                            <div class="id">ID : ${uuidv4()}</div>
                            <hr />
                            <div class="exclamation">
                              <i class="fas fa-exclamation-circle text-danger" aria-hidden="true"></i>
                              <div class="d-block">
                                <div class="mismatch">REASON_INSTALL_FAILED_DUE_TO_ICCID_MISMATCH(${misMatch})</div>
                                <div class="unknown-reason">Unknown reason</div>
                              </div>
                            </div>
                            <hr />
                            <div class="exclamation">
                              <i class="fas fa-exclamation-circle text-danger" aria-hidden="true"></i>
                              <div class="d-block">
                                <div class="mismatch">STATUS_OK(0)</div>
                                <div class="unknown-reason">Unknown reason</div>
                              </div>
                            </div>
                            <hr />
                            <div class="exclamation">
                              <div class="notification-title">Notification</div>
                              <div class="notification-body">Profile Install Error</div>
                            </div>
                            <hr />
                            <div class="exclamation">
                              <div class="notification-title">Notification</div>
                              <div class="notification-body">profile-installation-error</div>
                            </div>
                            <hr />
                          </div>`,
              timeout: 45000,
              type: "white",
            });
          }
        });
      }
    },
  },
};
</script>
